import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/gtm';
import HomePage from './pages/HomePage';
import OpeningTrainerPage from './pages/OpeningTrainerPage';
import CourseCreatorPage from './pages/CourseCreatorPage';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes
    trackPageView(
      document.title,
      window.location.href,
      location.pathname + location.search
    );
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/course-creator/new" element={<CourseCreatorPage />} />
      <Route path="/:openingSlug" element={<OpeningTrainerPage />} />
      <Route path="/:openingSlug/:lineSlug" element={<OpeningTrainerPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
